import Vue from 'vue'
import VueRouter from 'vue-router'
import mainLayout from '@/views/htui/layout'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  /**
   * 登录路由
   */
  {
    path: '/loginPage',
    component: () => import('@/views/components/loginPage'),
    name: 'loginPage'
  },
  /**
   * 主路由
   */
  {
    path: '',
    component: mainLayout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/htui/pages/index'),
        name: 'index'
      },
      {
        path: '/releaseEquityInfo',
        component: () => import('@/views/htui/pages/releaseEquityInfo'),
        name: 'releaseEquityInfo'
      },
      {
        path: '/releaseTechnicalLead',
        component: () => import('@/views/htui/pages/releaseTechnicalLead'),
        name: 'releaseTechnicalLead'
      },
      {
        path: '/releaseRegistered',
        component: () => import('@/views/htui/pages/releaseRegistered'),
        name: 'releaseRegistered'
      },
      {
        path: '/releasePurchase',
        component: () => import('@/views/htui/pages/releasePurchase'),
        name: 'releasePurchase'
      },
      {
        path: '/releaseQservices',
        component: () => import('@/views/htui/pages/releaseQservices'),
        name: 'releaseQservices'
      },
      {
        path: '/detailService',
        component: () => import('@/views/htui/pages/detailService'),
        name: 'detailService'
      },

      
      {
        path: '/detailEquityinfo',
        component: () => import('@/views/htui/pages/detailEquityinfo'),
        name: 'detailEquityinfo'
      },
      {
        path: '/detailTechnicalLead',
        component: () => import('@/views/htui/pages/detailTechnicalLead'),
        name: 'detailTechnicalLead'
      },
      {
        path: '/detailRegister',
        component: () => import('@/views/htui/pages/detailRegister'),
        name: 'detailRegister'
      },
      {
        path: '/profile/:id?',
        component: () => import('@/views/htui/pages/profile'),
        name: 'profile'
      },
       {
        path: '/agreement/service',
        component: () => import('@/views/components/xieyi/service'),
        name: 'service'
      },
       {
        path: '/agreement/privacy',
        component: () => import('@/views/components/xieyi/privacy'),
        name: 'privacy'
      },
      // 帮助中心相关路由
      {
        path: '/helpCenter',
        component: () => import('@/views/components/helpCenter/index'),
        name: 'helpCenter'
      },
      {
        path: '/detailPurchase',
        component: () => import('@/views/htui/pages/detailPurchase'),
        name: 'detailPurchase'
      },

      
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

